import { faCaretDown } from '@fortawesome/duotone-regular-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';

import Box from '~/common/components/Box';
import useCreditReportLinks from '~/common/components/Credit/useCreditReportLinks';
import Link from '~/common/components/Link';
import useGetLoanSummary from '~/common/hooks/useGetLoanSummary';
import Button from '~/common/mui/Buttons/MUIButton/MUIButton';

export default function CreditReportLink({
  button,
}: Readonly<{ button?: boolean }>) {
  const { data: loanSummary } = useGetLoanSummary();
  const { data } = useCreditReportLinks(
    loanSummary?.loanInfo?.underwritingMethod === 'Desktop Underwriter'
      ? 'DU'
      : 'LPA',
    undefined,
    !!loanSummary,
  );
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef();

  if (!data?.creditReportLinks?.length) {
    return null;
  }

  if (button) {
    return (
      <>
        <Button
          variant="outlined"
          endIcon={
            data?.creditReportLinks?.length > 1 && (
              <FontAwesomeIcon icon={faCaretDown} />
            )
          }
          onClick={() => {
            if (data?.creditReportLinks?.length == 1) {
              window.open(data.creditReportLinks[0].creditReportUri, '_blank');
              return;
            }

            setIsOpen(!isOpen);
          }}
          ref={anchorRef}
        >
          Credit Report
        </Button>
        <Menu
          open={isOpen}
          onClose={() => setIsOpen(false)}
          anchorEl={anchorRef.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {data.creditReportLinks.map((link) => (
            <MenuItem
              key={link.customerIdentifiers[0].customerRecordId}
              onClick={() => setIsOpen(false)}
            >
              <Link
                href={link.creditReportUri}
                target="_blank"
                sx={{
                  color: 'blue.600',
                }}
              >
                {link.displayName}
              </Link>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}
    >
      {data.creditReportLinks.map((link) => (
        <Link
          key={link.customerIdentifiers[0].customerRecordId}
          href={link.creditReportUri}
          target="_blank"
          sx={{
            color: 'blue.600',
          }}
        >
          {link.displayName} <FontAwesomeIcon icon={faExternalLinkAlt} />
        </Link>
      ))}
    </Box>
  );
}
